"use client";
import { useState } from "react";

export default function Faqs() {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="kg-card kg-toggle-card "
      data-kg-toggle-state={open ? "open" : "close"}
    >
      <div
        className="kg-toggle-heading flex gap-5"
        onClick={() => setOpen(!open)}
        style={{ cursor: "pointer" }}
      >
        <h4 className="kg-toggle-heading-text ">
          <span style={{ whiteSpace: "pre-wrap" }}>
            How do you choose advertisers and partners?
          </span>
        </h4>

        <button
          className="kg-toggle-card-icon"
          aria-label="Expand toggle to read content"
          type="button"
          style={{
            background: "none",
            border: "none",
            padding: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="20"
            height="20"
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          >
            <path
              d="M23.25 7.311L12.53 18.03a.749.749 0 0 1-1.06 0L.75 7.311"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {open && (
        <div className="kg-toggle-content">
          <p>
            <span style={{ whiteSpace: "pre-wrap" }}>
              We carefully select our advertisers and partners to ensure that
              they are legitimate and offer value to our users.
            </span>
            <br />
            <span style={{ whiteSpace: "pre-wrap" }}>
              We assess their reputation, the quality of their products or
              services and the transparency of their business practices before
              establishing a partnership.
            </span>
          </p>
        </div>
      )}
    </div>
  );
}
